import {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {trackPageView} from '../utils/metaPixel';

/**
 * Fires Meta Pixel PageView on client-side route changes.
 * Initial PageView is handled by the base snippet in public/index.html.
 */
class MetaPixelPageView extends Component {
    componentDidMount() {
        this.unlisten = this.props.history.listen(() => {
            trackPageView();
        });
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
    }

    render() {
        return null;
    }
}

export default withRouter(MetaPixelPageView);
